import React from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { openModal } from 'src/actions/modals';


const ImageView = (props) => {
  const { dispatch } = props;
  const zoom = () => {
    dispatch(
      openModal('IMAGE_MODAL', {
        src: props.src,
      })
    );
  };
  return (
    <React.Fragment>
      <div>
        <img
          src={props.src}
          onClick={zoom}
          style={{ maxHeight: '200px', maxWidth: '400px', cursor: 'pointer' }}
        />
      </div>
    </React.Fragment>
  );
};

export default compose(connect())(ImageView);
